import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import ErrorBoundary from '.';
export function withErrorBoundary(Component, debugComponent) {
    const decorated = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: debugComponent
        }, /*#__PURE__*/ React.createElement(Component, _object_spread_props(_object_spread({}, props), {
            key: `${debugComponent}ErrorBoundary`
        })));
    decorated.displayName = `withErrorBoundary(${Component.displayName || 'Component'})`;
    return decorated;
}

//# sourceMappingURL=withErrorBoundary.js.map